import axios from "axios";

export const APIRequest = async (method, url, data, config = undefined, settings = {}) => {
    // Check if there's a filename in the headers and encode it if necessary
    if (config?.headers && config?.headers?.filename) {
        const filename = config.headers.filename;
        // Encode only if the filename contains non-ASCII characters
        if (/[^\x00-\x7F]/.test(filename)) {
            config.headers.filename = 'file';
        }
    }

    try {
        const response = await axios[method.toLowerCase()](url, data, config);
        return response;
    } catch (error) {
        if (settings.optimistic) return;
        const status = error?.response?.status;

        if (error?.code?.startsWith("ECONNABORTED") && error.message.startsWith('timeout of ')) {
            return window.dispatchEvent(new CustomEvent('requestTimeout', {detail: {message: error.message}}));
        }

        if (error?.code?.startsWith("ERR_NETWORK")) {
            if (error?.config?.data?.length > 1024*1024*6) {
                window.dispatchEvent(new CustomEvent('sizeTooLarge', {detail: {message: error.message}}));
            } else {
                window.dispatchEvent(new CustomEvent('networkError', {detail: {message: error.message}}));
            }

            return;
        }

        console.error(`API request error to url ${url} status ${status}:`, error);

        if (status === 401) {
            window.dispatchEvent(new Event('unauthorizedError'));
            return;
        } else if (status === 500) {
            let message = error.message;
            if (error?.response?.data?.error) message = error?.response?.data?.error;
            window.dispatchEvent(new CustomEvent('internalServerError', {
                detail: { message }
            }));
            return;
        } else {
            throw error;
        }
    }
};
